import { create } from 'zustand';
import { api } from '../services/services/APIs';



const getPersonaIdFromUser = (user) => {
  if (!user || typeof user !== 'object') return '';
  const candidates = [
    user.personaId,
    user.PersonaID,
    user.persona_id,
    user.idPersona,
    user.id,
  ];
  for (const value of candidates) {
    const parsed = String(value ?? '').trim();
    if (parsed) return parsed;
  }
  return '';
};

export const useEmpresaStore = create((set, get) => ({
  empresa: null,
  loading: false,
  error: null,
  submitting: false,
  success: null,

  fetchEmpresa: async (user) => {
    const personaId = getPersonaIdFromUser(user);
    if (!personaId) {
      set({ error: 'No se encontró personaId en la sesión.' });
      return;
    }

    set({ loading: true, error: null });
    try {
      const res = await api.empresas.findEmpresaByUsuario(personaId);
      const raw = await res.json();
      if (raw) {
        const domicilio = raw.Domicilio || {};
        const mappedEmpresa = {
          id: raw.EmpresaID || raw.empresaId || raw.id || raw.idEmpresa || '',
          nombre: raw.Nombre || raw.nombre || '',
          rfc: raw.RFC || raw.rfc || '',
          razonSocial: raw.RazonSocial || raw.razonSocial || '',
          telefono: raw.Telefono || raw.telefono || '',
          correo: raw.Correo || raw.correo || '',
          logo: raw.ImagenEmpresa || raw.logo || '',
          calle: domicilio.Calle || raw.calle || '',
          numExt: domicilio.NumExt || raw.numExt || '',
          numInt: domicilio.NumInt || raw.numInt || '',
          extra: domicilio.Referencias || raw.extra || '',
          entre: domicilio.Entre1 && domicilio.Entre2 
            ? `${domicilio.Entre1} y ${domicilio.Entre2}` 
            : (domicilio.Entre1 || raw.entre || ''),
          colonia: domicilio.Colonia || raw.colonia || '',
          cp: domicilio.CodigoPostal || raw.cp || '',
          pais: domicilio.Pais || raw.pais || '',
          estado: domicilio.Estado || raw.estado || '',
          metaVenta: raw.metaVenta || 0,
          puntoEquilibrio: raw.puntoEquilibrio || 0,
        };
        set({
          empresa: mappedEmpresa,
          loading: false,
        });
      } else {
        set({ error: 'No se encontró información de la empresa.', loading: false });
      }
    } catch (err) {
      console.error('Error fetching empresa:', err);
      set({ error: 'Ocurrió un error al cargar la empresa.', loading: false });
    }
  },

  updateEmpresa: async (formData) => {
    const empresaId = get().empresa?.id;
    if (!empresaId) {
      set({ error: 'No se encontró el ID de la empresa para actualizar.' });
      return;
    }

    set({ submitting: true, error: null, success: null });
    try {
      // Llamada real a la API
      await api.empresas.updateEmpresa(empresaId, formData);
      
      set({ 
        empresa: { ...get().empresa, ...formData },
        submitting: false, 
        success: '¡Configuración guardada correctamente!' 
      });

      setTimeout(() => set({ success: null }), 3000);
    } catch (err) {
      console.error('Error updating empresa:', err);
      set({ error: 'Error al guardar los cambios en el servidor.', submitting: false });
    }
  }
}));
